import Vue from "vue"
import Vuex from "vuex"

import auth from "./auth"
import concerts from "./concerts"
import core from "./core"
import events from "./events"
import instruments from "./instruments"
import people from "./people"
import places from "./places"
import shows from "./shows"
import transports from "./transports"
import hotels from "./hotels"
import bookings from "./bookings"
import vouchers from "./vouchers"
import aggregatedData from './aggregatedData'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: { auth, concerts, core, events, instruments, people, places, shows, transports, hotels, bookings, vouchers, aggregatedData },
})
